import styled from 'styled-components';

export const TabsList = styled.ul<{ height: number }>`
  height: ${({ height }) => height}px;
  display: flex;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 14px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    height: 54px;
    min-width: 414px;
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 414px;
  }
`;
